module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/082-united-nations-a866fff0d14355f21e26b04471117bce.svg";